import React, { useState, useEffect, useCallback, useContext } from 'react';
import './Login.css';
import LockIcon from '@mui/icons-material/Lock';
import { makeStyles } from '@mui/styles';
import { Logo } from '../../components/Logo/';
import { ThemeContext } from '../../lib/contexts/ThemeContext';

import {
  Button,
  Grid,
  Typography,
  TextField,
  FormControl,
  LinearProgress,
  Paper,
  Checkbox,
  FormGroup,
  FormControlLabel,
  AccordionSummary,
  Accordion,
} from '@mui/material';
import { PartnerContext, UserContext } from '../../lib/contexts';
import { getCookie, setCookie } from '../../lib/helpers/helpers';
import { KeyboardArrowDown, KeyboardArrowLeft, KeyboardArrowUp } from '@mui/icons-material';
import { mix_hexes } from '../../lib/helpers/colorHelpers';
import { postUserLogin } from '../../lib/api';
import MarkdownRenderer from '../../components/MarkdownRenderer';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  bgshape1: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100vh',
    zIndex: -1,
    backgroundColor: theme.palette.primary.main, // || '#3f83d1',
  },
  bgshape2: {
    transform: 'rotate(' + Math.floor(Math.random() * 45 + 10) + 'deg)',
    position: 'fixed',
    right: -500,
    top: -100,
    width: 0,
    height: 0,
    borderTop: '100vh solid transparent',
    borderBottom: '100vh solid transparent',
    borderLeft:
      theme.palette.primary.main && theme.palette.secondary.main
        ? '100vh solid ' + mix_hexes(theme.palette.primary.main, theme.palette.secondary.main)
        : '100vh solid #b6b6b6',
    zIndex: -1,
    backgroundColor:
      theme.palette.primary.main && theme.palette.secondary.main
        ? mix_hexes(theme.palette.primary.main, theme.palette.secondary.main)
        : '#b6b6b6',
  },
  bgshape3: {
    transform: 'rotate(' + Math.floor(Math.random() * 40 + 1) + 'deg)',
    position: 'fixed',
    left: '-50vh',
    top: '-55vh',
    width: 0,
    height: 0,
    borderTop: '100vh solid transparent',
    borderBottom: '100vh solid transparent',
    borderLeft: '100vh solid ' + theme.palette.secondary.main,
    zIndex: -1,
    backgroundColor: theme.palette.secondary.main, // || '#ff0044',
  },
  paper: {
    minWidth: 400,
    width: '80vw',
    minHeight: '65vh',
    maxWidth: 1000,
    paddingBottom: 15,
    margin: '15vh auto 5vh',
    backgroundColor: theme.palette.common.white,
    borderRadius: 8,
    [theme.breakpoints.down('lg')]: {
      margin: '5vh auto 5vh',
      minHeight: '80vh',
    },
    [theme.breakpoints.down('md')]: {
      margin: '5vh auto 5vh',
      minHeight: '90vh',
      width: '90vw',
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 600,
    },
  },
  container: {
    width: '100%',
    minWidth: 300,
    margin: 'auto',
    display: 'block',
    overflowY: 'auto',
  },
  welcomeMessage: {
    marginTop: 0,
    fontSize: '1.4rem',
    margin: 'auto',
    marginBottom: 15,
    textAlign: 'center',
    maxWidth: '60%',
    [theme.breakpoints.down('lg')]: {
      maxWidth: '75%',
      fontSize: '1.3rem',
    },
    [theme.breakpoints.down('md')]: {
      maxWidth: '90%',
      fontSize: '1.1rem',
    },
    '& img': {
      maxHeight: 200,
      margin: '10px auto 0',
    },
  },
}));

const LoginScreen = (props) => {
  const urlParams = new URLSearchParams(window.location.search);
  const {
    state: { finalTheme },
  } = useContext(ThemeContext);
  const classes = useStyles();
  const {
    actions: { setUser },
  } = useContext(UserContext);

  const {
    state: { welcome_message, id = 1 },
  } = useContext(PartnerContext);
  const [status, setStatus] = useState(null);
  const [emailBad, setEmailBad] = useState(false);
  const [tryingLogin, setTryingLogin] = useState(false);
  const [showMore, setShowMore] = useState(false);
  const [OTPLogin, setOTPLogin] = useState(false);
  const [accessCodeLogin, setAccessCodeLogin] = useState(false);
  const [rememberMe, setRememberMe] = useState(true);
  const [loginEmail, setLoginEmail] = useState();
  const [phone, setPhone] = useState();
  const [accessCode, setAccessCode] = useState('');
  const [OTP, setOTP] = useState('');
  const [helperText, setHelperText] = useState('');
  const isDarkMode = localStorage.getItem('THEME') === 'true';

  useEffect(() => {
    const phoneFromCookie = getCookie('phone');
    if (phoneFromCookie) {
      setPhone(phoneFromCookie);
    }
    const emailFromCookie = getCookie('email');
    if (!phoneFromCookie && emailFromCookie) {
      setLoginEmail(emailFromCookie);
    }
  }, []);

  const loginRequest = useCallback(async () => {
    setStatus(null);
    setTryingLogin(true);
    const loginData = {
      user: {
        ...(!(accessCodeLogin || phone) && { email: loginEmail }),
        ...(!(accessCodeLogin || loginEmail) && { phone }),
        ...(accessCodeLogin && { access_code: accessCode }),
        ...(!accessCodeLogin && OTP && { otp: OTP }),
      },
    };
    try {
      const { data } = await postUserLogin(loginData, id);
      if (data && (data.email || data.phone)) {
        setTryingLogin(false);
        if (!accessCodeLogin) {
          setOTPLogin(true);
        }
      } else if (data) {
        data.user.partner_admin && 1 === 2
          ? sessionStorage.setItem(
              'DQPN_AUTH',
              JSON.stringify({
                user: data.user,
                user_id: data.user.id,
                partner_id: data.user.partner_id,
                nav_user_id: data.nav_user_id,
                auth_token: data.auth_token,
              }),
            )
          : localStorage.setItem(
              'DQPN_AUTH',
              JSON.stringify({
                user: data.user,
                user_id: data.user.id,
                partner_id: data.user.partner_id,
                nav_user_id: data.nav_user_id,
                auth_token: data.auth_token,
              }),
            );

        setUser(data.user);

        if (rememberMe && loginEmail) {
          setCookie('email', loginEmail);
        }
        if (rememberMe && phone) {
          setCookie('phone', phone);
        }

        window.location = window.location.protocol + '//' + window.location.host + '/';
        setTryingLogin(false);
      } else {
        setStatus('failure');
        setTryingLogin(false);
      }
    } catch (error) {
      console.error(error);
      setStatus('failure');
      setTryingLogin(false);
    }
  }, [loginEmail, accessCode, OTP, phone, OTPLogin, props]);

  const validateEmail = useCallback((email) => {
    const re =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }, []);

  useEffect(() => {
    if (OTPLogin && OTP?.length > 5) {
      loginRequest();
    }
  }, [OTPLogin, OTP, loginRequest]);

  return (
    <>
      <Paper
        className={classes.paper}
        elevation={12}
        style={{ backgroundColor: finalTheme.palette.background.paper }}
      >
        <div style={{ padding: '2.5vh', textAlign: 'center' }}>
          <Logo
            height="70px"
            variant={'logo'}
          />
        </div>
        <div className={classes.container}>
          <Grid
            container
            alignItems="center"
          >
            <Grid
              item
              xs
            >
              <Typography
                className={classes.welcomeMessage}
                gutterBottom
                variant="h4"
                style={{ color: isDarkMode == true ? 'white' : 'black' }}
              >
                <MarkdownRenderer markdownText={welcome_message} />
              </Typography>
              <Typography
                gutterBottom
                variant="h6"
                style={{
                  fontSize: '1.0rem',
                  textAlign: 'center',
                  color: isDarkMode == true ? 'white' : 'black',
                }}
              >
                {status === 'failure'
                  ? 'Please double-check the destination for your OTP.'
                  : OTPLogin
                  ? 'Please enter the One-Time-Password sent to your Device:'
                  : 'Enter your credentials below:'}
              </Typography>
            </Grid>
          </Grid>
          <Grid
            style={{ width: 300, margin: 'auto' }}
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
            spacing={0}
          >
            {OTPLogin || accessCodeLogin ? (
              <Grid
                item
                xs={12}
                style={{ marginBottom: 15 }}
              >
                <FormControl style={{ width: 300 }}>
                  <TextField
                    error={status === 'failure' ? true : false}
                    className="field"
                    key="otp"
                    id="otp"
                    label={accessCodeLogin ? 'Enter Code' : 'Enter One-Time-Password'}
                    value={OTPLogin ? OTP : accessCode}
                    onChange={(event) => {
                      if (OTPLogin) {
                        setOTP(event.target.value);
                      } else if (accessCodeLogin) {
                        setAccessCode(event.target.value);
                      }
                    }}
                    margin="normal"
                    variant="outlined"
                    fullWidth={true}
                    disabled={tryingLogin}
                    type={'text'}
                  />
                </FormControl>
                <Button
                  variant={'text'}
                  style={{ display: 'block', margin: 'auto' }}
                  onClick={() => {
                    setAccessCodeLogin(false);
                    setOTPLogin(false);
                  }}
                >
                  <KeyboardArrowLeft style={{ marginBottom: -7, marginRight: -2 }} /> Back
                </Button>
              </Grid>
            ) : (
              <>
                <Accordion
                  elevation={0}
                  expanded={!showMore}
                >
                  <AccordionSummary
                    style={{ height: 0, display: 'none' }}
                    aria-controls="emailLogin"
                    id="emailLogin"
                  >
                    &nbsp;
                  </AccordionSummary>
                  <Grid
                    item
                    xs={12}
                    style={{ marginBottom: 15 }}
                  >
                    <FormControl style={{ width: 300 }}>
                      <TextField
                        error={status === 'failure' ? true : false}
                        className="field"
                        key="otp"
                        id="otp"
                        label={'Enter Phone Number'}
                        value={phone}
                        onChange={(event) => {
                          let val = event.target.value.replace(/[^0-9]/g, '');
                          if (val?.length < 11) {
                            setPhone(val);
                          }
                        }}
                        margin="normal"
                        variant="outlined"
                        fullWidth={true}
                        disabled={tryingLogin || loginEmail}
                        type={'text'}
                        inputProps={{
                          max: 10,
                        }}
                      />
                    </FormControl>
                    <Typography style={{ textAlign: 'center', margin: 'auto' }}>- OR -</Typography>
                    <FormControl style={{ width: 300 }}>
                      <TextField
                        error={status === 'failure' || emailBad ? true : false}
                        className="field"
                        id="email"
                        key="email"
                        label="Enter Email"
                        value={loginEmail}
                        margin="normal"
                        variant="outlined"
                        fullWidth={true}
                        disabled={tryingLogin || phone}
                        onChange={(event) => {
                          setEmailBad(!validateEmail(event.target.value));
                          setLoginEmail(event.target.value);
                        }}
                        type={'email'}
                        helperText={helperText}
                        InputProps={{
                          style: {
                            color: isDarkMode ? 'white' : 'black',
                          },
                        }}
                        InputLabelProps={{
                          style: {
                            color: isDarkMode ? 'white' : 'black',
                          },
                        }}
                      />
                    </FormControl>
                  </Grid>
                </Accordion>
                {!tryingLogin && (
                  <Accordion
                    elevation={0}
                    expanded={showMore}
                    onChange={() => setShowMore(!showMore)}
                  >
                    <AccordionSummary
                      aria-controls="moreWays"
                      id="moreWays"
                    >
                      <Typography style={{ textAlign: 'center', margin: 'auto' }}>
                        More Login Options
                        <br />
                        {showMore ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                      </Typography>
                    </AccordionSummary>
                    <Grid
                      item
                      xs={12}
                      style={{ marginBottom: 15, textAlign: 'left' }}
                    >
                      <Button
                        fullWidth
                        variant={'text'}
                        onClick={() => setAccessCodeLogin(!accessCodeLogin)}
                      >
                        Login via Access Code
                      </Button>
                    </Grid>
                  </Accordion>
                )}
              </>
            )}

            {tryingLogin ? (
              <LinearProgress
                color="primary"
                style={{ width: '80%', display: 'block', textAlign: 'center', margin: '20px auto 20px auto' }}
              />
            ) : (
              <Button
                disabled={
                  !(
                    (emailBad === false && loginEmail !== '') ||
                    (phone?.length === 10 && phone !== '') ||
                    (accessCodeLogin && accessCode?.length >= 5)
                  )
                }
                variant="contained"
                style={{
                  width: 300,
                  marginBottom: 20,
                  marginTop: 0,
                  backgroundColor: finalTheme.palette.primary.main,
                  color: finalTheme.palette.primary.contrastText,
                }}
                onClick={() => loginRequest()}
              >
                Sign In &nbsp;
                <LockIcon />
              </Button>
            )}

            {!tryingLogin && !OTPLogin && !accessCodeLogin && (
              <Grid
                item
                xs={12}
                style={{ marginBottom: 15 }}
              >
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        defaultChecked
                        checked={rememberMe}
                        onChange={(event) => {
                          setRememberMe(!rememberMe);
                        }}
                      />
                    }
                    label="Remember Me?"
                  />
                </FormGroup>
              </Grid>
            )}
          </Grid>
        </div>
      </Paper>
      <div className={classes.bgshape1}></div>
      <div className={classes.bgshape2}></div>
      <div className={classes.bgshape3}></div>
    </>
  );
};

export default LoginScreen;
